import { AuthSession } from './models'

const AUTH_SESSION_CHANNEL_NAME = 'lawyer-portal-auth-session'

enum AuthSessionMessageType {
  SESSION_REFRESHED = 'sessionRefreshed',
  SESSION_ENDED = 'sessionEnded'
}

type AuthSessionMessage =
  | { type: AuthSessionMessageType.SESSION_REFRESHED; session: AuthSession }
  | { type: AuthSessionMessageType.SESSION_ENDED }

const openAuthSessionChannel = (): BroadcastChannel | undefined =>
  typeof BroadcastChannel === 'undefined'
    ? undefined
    : new BroadcastChannel(AUTH_SESSION_CHANNEL_NAME)

const publishAuthSessionMessage = (message: AuthSessionMessage): void => {
  const channel = openAuthSessionChannel()

  channel?.postMessage(message)
  channel?.close()
}

export const publishRefreshedAuthSession = (session: AuthSession): void =>
  publishAuthSessionMessage({ type: AuthSessionMessageType.SESSION_REFRESHED, session })

export const publishEndedAuthSession = (): void =>
  publishAuthSessionMessage({ type: AuthSessionMessageType.SESSION_ENDED })

export const subscribeToAuthSessionMessages = ({
  onRefreshedAuthSession,
  onEndedAuthSession
}: {
  onRefreshedAuthSession: (session: AuthSession) => void
  onEndedAuthSession: () => void
}): void => {
  const channel = openAuthSessionChannel()

  if (!channel) {
    return
  }

  channel.onmessage = ({ data }: MessageEvent<AuthSessionMessage>) => {
    switch (data.type) {
      case AuthSessionMessageType.SESSION_REFRESHED:
        return onRefreshedAuthSession(data.session)

      case AuthSessionMessageType.SESSION_ENDED:
        return onEndedAuthSession()
    }
  }
}
